// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1__d45d5cbd20ffea8c848c","cls2":"PaperContainer-cls2__e1b62fc1e3d7ffebbeed PaperContainer-cls1__d45d5cbd20ffea8c848c"};